/**
 * @remarks Audio, editorial and video are values of an article's `type` field. A close
 * look is a Sanity document type of its own, indexed separately, so `data.ts` filters it
 * on `sanityType` instead. Kept out of `_filters.tsx` so `data.ts` can share it without
 * pulling a client component into a server module.
 */
export type PerspectivesMediaType =
	| 'audio'
	| 'closeLook'
	| 'editorial'
	| 'video';

export const PERSPECTIVES_MEDIA_TYPES: Array<{
	description?: string;
	label: string;
	value: PerspectivesMediaType;
}> = [
	{ value: 'editorial', label: 'Articles' },
	{ value: 'video', label: 'Videos' },
	{ value: 'audio', label: 'Audio' },
	{
		value: 'closeLook',
		label: 'Close Look',
		description: 'Visual essays about art in The Met collection.',
	},
];
